<div
  class="ql-editor ql-comment mb-3"
  *ngIf="comment?.parent">
  <blockquote>
    <div class="font-medium">{{ comment?.parent?.user?.profile?.name }}</div>
    <div
      [innerHTML]="comment?.parent?.text | truncate: 180"
      class="mt-2"></div>
  </blockquote>
</div>
<crm-editor
  #editor
  [(value)]="comment.text"
  (onPaste)="onPaste($event)"
  [height]="height"
  (onTextChange)="changeTextHandler($event)"
  (drop)="dropFiles($event)"></crm-editor>

<crm-files-list
  *ngIf="comment.files?.length"
  [files]="toFiles(comment.files)"
  [canDelete]="true"
  (deleteFile)="deleteFile($event)"></crm-files-list>

<div class="mt-3 flex justify-content-between">
  <div class="flex">
    <button
      *ngIf="isShowSendButton"
      pButton
      label="Написать"
      icon="pi pi-send"
      class="p-button-success mr-2"
      [disabled]="!comment.text?.length && !comment.files?.length"
      (click)="saveComment()"></button>
    <crm-file-uploader
      [multiple]="true"
      (filesUploaded)="attachFiles($event)"></crm-file-uploader>
  </div>

  <button
    pButton
    label="Очистить"
    icon="pi pi-undo"
    class="p-button-secondary p-button-text"
    (click)="resetCommentForm()"></button>
</div>
